import axios from "axios";

/**
 * KDS REST client.
 *
 * The KDS needs a signed-in person (bible §29, amended 2026-10-20). The server
 * gives each person only their own stations (kitchen vs bar) and refuses the
 * rest. Every call carries the stored session's token, so the KDS screen and the
 * admin station pickers authenticate without each caller passing one.
 */
const base = `${process.env.REACT_APP_BACKEND_URL || ""}/api/kds`;
const SESSION_KEY = "vibez-session";

const auth = () => {
  try {
    const token = JSON.parse(localStorage.getItem(SESSION_KEY) || "null")?.token;
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  } catch {
    return {};
  }
};

export const listTickets = async printerId => {
  const params = printerId ? { printer_id: printerId } : {};
  const { data } = await axios.get(`${base}/tickets`, { ...auth(), params });
  return data;
};

export const listStations = async () => {
  const { data } = await axios.get(`${base}/printers`, auth());
  return data;
};

export const getKdsSettings = async stationId => {
  const params = stationId ? { station_id: stationId } : {};
  const { data } = await axios.get(`${base}/settings`, { ...auth(), params });
  return data;
};

/** Advance a whole ticket. Bumps are forward-only; the server rejects going back. */
export const bumpTicket = async (orderId, kotNumber, status) => {
  const { data } = await axios.patch(`${base}/tickets/${orderId}/${kotNumber}/status`, { status }, auth());
  return data;
};

/**
 * Undo the last bump on a ticket. The server finds the batch by its shared
 * audit_log timestamp and refuses outside the configured recall window, so this
 * can fail legitimately — surface the message rather than assuming success.
 */
export const recallTicket = async (orderId, kotNumber, stationId) => {
  const params = stationId ? { station_id: stationId } : {};
  const { data } = await axios.post(`${base}/tickets/${orderId}/${kotNumber}/recall`, null, { ...auth(), params });
  return data;
};
